(function (global, factory) {
  const api = factory(global);

  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }

  if (!global || !global.document) return;

  function getFilterLayout(control) {
    const section = control && control.closest('.aoy-print-collection');
    return section && section.querySelector('.aoy-print-collection__layout');
  }

  function syncAllFilterDrawers() {
    global.document.querySelectorAll('.aoy-print-collection__layout').forEach(function (layout) {
      api.syncFilterDrawer(layout, global.document);
    });
  }

  global.document.addEventListener('click', function (event) {
    const toggle = event.target.closest('.aoy-print-collection .toggle-filtering');
    if (!toggle) return;

    const layout = getFilterLayout(toggle);
    const drawer = layout && layout.closest('.aoy-print-collection').querySelector('.aoy-print-collection__filters');
    if (drawer) drawer.inert = false;
  }, true);

  global.document.addEventListener('click', function (event) {
    const button = event.target.closest('[data-aoy-load-more]');
    if (button) {
      event.preventDefault();
      api.loadNextPage(button).catch(function (error) {
        console.error('Unable to load more prints:', error);
      });
      return;
    }

    const closeControl = event.target.closest('[data-aoy-filter-close], .aoy-print-collection .facets__mobile-close');
    if (closeControl) {
      event.preventDefault();
      api.requestFilterDrawerClose(getFilterLayout(closeControl), global.document, closeControl);
      return;
    }

    const toggle = event.target.closest('.aoy-print-collection .toggle-filtering');
    if (toggle) {
      global.requestAnimationFrame(function () {
        api.syncFilterDrawer(getFilterLayout(toggle), global.document);
      });
    }
  });

  global.document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;

    const openLayout = global.document.querySelector(
      '.aoy-print-collection__layout.grid-archive__main-container--filters-shown, ' +
      '.aoy-print-collection__layout.grid-archive__main-container-mobile--filters-shown'
    );
    if (openLayout) api.requestFilterDrawerClose(openLayout, global.document);
  });

  global.addEventListener('resize', syncAllFilterDrawers);
  global.document.querySelectorAll('.aoy-print-collection__layout').forEach(function (layout) {
    new global.MutationObserver(function () {
      api.syncFilterDrawer(layout, global.document);
    }).observe(layout, { attributes: true, attributeFilter: ['class'] });
  });
  syncAllFilterDrawers();
})(typeof window !== 'undefined' ? window : undefined, function (global) {
  function isFilterDrawerOpen(layout) {
    return Boolean(layout) && (
      layout.classList.contains('grid-archive__main-container--filters-shown') ||
      layout.classList.contains('grid-archive__main-container-mobile--filters-shown')
    );
  }

  function syncFilterDrawer(layout, documentRef) {
    if (!layout || !documentRef) return false;

    const section = layout.closest('.aoy-print-collection');
    const toggle = section && section.querySelector('.toggle-filtering');
    const drawer = section && section.querySelector('.aoy-print-collection__filters');
    const isOpen = isFilterDrawerOpen(layout);

    documentRef.body.classList.toggle('aoy-filter-drawer-open', isOpen);
    if (!isOpen) releaseFilterScrollLock(documentRef);
    if (toggle) toggle.setAttribute('aria-expanded', String(isOpen));
    if (drawer) {
      drawer.setAttribute('aria-hidden', String(!isOpen));
      drawer.inert = !isOpen;
    }

    return isOpen;
  }

  function releaseFilterScrollLock(documentRef) {
    if (!documentRef || !documentRef.body) return;

    const hasOpenMobileFilter = documentRef.querySelector && documentRef.querySelector(
      '.grid-archive__main-container-mobile--filters-shown'
    );

    if (!hasOpenMobileFilter) {
      documentRef.body.classList.remove('no-scroll--laptop-down');
    }
  }

  function closeFilterDrawer(layout, documentRef) {
    if (!layout || !documentRef) return;

    const section = layout.closest('.aoy-print-collection');
    const toggle = section && section.querySelector('.toggle-filtering');

    layout.classList.remove(
      'grid-archive__main-container--filters-shown',
      'grid-archive__main-container-mobile--filters-shown'
    );
    syncFilterDrawer(layout, documentRef);
    if (toggle) toggle.focus();
  }

  function requestFilterDrawerClose(layout, documentRef, sourceControl) {
    if (!layout || !documentRef) return;

    const isMobileOpen = layout.classList.contains('grid-archive__main-container-mobile--filters-shown');
    const nativeClose = layout.querySelector && layout.querySelector('.facets__mobile-close');
    if (isMobileOpen && nativeClose && nativeClose !== sourceControl) nativeClose.click();

    closeFilterDrawer(layout, documentRef);
  }

  async function loadNextPage(button, options) {
    const settings = options || {};
    const fetchImpl = settings.fetchImpl || global.fetch.bind(global);
    const parseHtml = settings.parseHtml || function (html) {
      return new global.DOMParser().parseFromString(html, 'text/html');
    };

    if (button.dataset.loading === 'true') return;

    const products = button.closest('.aoy-print-collection__products');
    const grid = products && products.querySelector('[data-aoy-print-grid]');
    const status = products && products.querySelector('[data-aoy-load-more-status]');
    const nextUrl = button.getAttribute('href');

    if (!products || !grid || !status || !nextUrl) return;

    const originalLabel = button.textContent;
    button.dataset.loading = 'true';
    button.setAttribute('aria-disabled', 'true');
    button.textContent = 'Loading...';

    try {
      const response = await fetchImpl(nextUrl, {
        headers: { 'X-Requested-With': 'XMLHttpRequest' },
      });
      if (!response.ok) throw new Error('Request failed with status ' + response.status);

      const nextDocument = parseHtml(await response.text());
      const nextGrid = nextDocument.querySelector('[data-aoy-print-grid]');
      if (!nextGrid) throw new Error('The next product grid was not found');

      const nextCards = Array.from(nextGrid.querySelectorAll('.aoy-print-card'));
      grid.append(...nextCards);

      const shownCount = grid.querySelectorAll('.aoy-print-card').length;
      const totalCount = Number(status.dataset.total || shownCount);
      status.textContent = 'Showing ' + shownCount + ' of ' + totalCount;

      const nextButton = nextDocument.querySelector('[data-aoy-load-more]');
      if (nextButton) {
        button.setAttribute('href', nextButton.getAttribute('href'));
      } else {
        button.remove();
      }
    } finally {
      if (button.isConnected) {
        delete button.dataset.loading;
        button.removeAttribute('aria-disabled');
        button.textContent = originalLabel;
      }
    }
  }

  return {
    closeFilterDrawer: closeFilterDrawer,
    loadNextPage: loadNextPage,
    releaseFilterScrollLock: releaseFilterScrollLock,
    requestFilterDrawerClose: requestFilterDrawerClose,
    syncFilterDrawer: syncFilterDrawer,
  };
});
